import {Skeleton} from 'primereact/skeleton';
import {Divider} from 'primereact/divider';

export default function SkeletonCard() {
    return <div className="border-round border-1 surface-border p-4 surface-card w-full">
        <Skeleton width="40%" height="2rem" className="mb-2"/>
        <Divider />
        <Skeleton width="100%" height="10rem"/>
    </div>
}